<template>
	<div>
		<form-dialog
			:appendToBody="true"
			:dialogVisible.sync="visable"
			@handleClose="convclose"
			dialogWidth="420px"
		>
			<dialogtitle slot="title" title="聊天转线索"></dialogtitle>
			<div class="turn-dialog">
				<div>是否确认将此聊天转为线索？</div>
				<div>线索名称: {{ nickname }}</div>
				<!-- <div>跟进人: {{userInfo.userName}}</div> -->
			</div>
			<dialogfooter
				slot="footer"
				:visible.sync="visable"
				@onclose="convclose"
				@confirm="convsubmit"
			></dialogfooter>
		</form-dialog>
	</div>
</template>
<script>
import formDialog from '@/components/webManage/formDialog.vue';
import dialogtitle from '@/components/crm/crm-dialog-title.vue';
import dialogfooter from '@/components/crm/crm-dialog-footer.vue';
import { mapGetters } from 'vuex';
import chatSer from '@/backend/services/chat/chatSer.js';
export default {
	props: {
		nickname: {
			type: String,
		},
		turn_visible: {
			type: Boolean,
		},
		messengerUserId: null,
		id: null,
	},
	data() {
		return {
			visable: false,
		};
	},
	watch: {
		turn_visible: {
			handler() {
				this.visable = this.turn_visible;
			},
		},
	},
	computed: {
		...mapGetters(['chatListData', 'userInfo', 'allChatList']),
	},
	methods: {
		convclose() {
			this.visable = false;
			this.$emit('update:turn_visible', false);
		},
		async convsubmit(cb) {
			cb();
			
			//fb用户id
			try {
				let res = await chatSer.chatManual({ id: this.messengerUserId });

				if (res.status == 200) {
					
					cb(false);
					this.convclose();
					this.$store.dispatch('setChatNoData', false);
					this.$message.success('聊天转为线索成功');
					if (this.$route.name == 'allChat') {
						this.allChatList.forEach(e => {
							if (e.id == this.id) {
								e.type = 1;
								e.tableId = this.messengerUserId;
								e.id = res.data;
							}
						});
						this.$store.dispatch('setAllChatList', this.allChatList);
					} else {
						this.chatListData.forEach(e => {
							if (e.id == this.id) {
								e.type = 1;
								e.tableId = this.messengerUserId;
								e.id = res.data;
							}
						});
						this.$store.dispatch('setChatListData', this.chatListData);
					}
				} else {
					cb(false);
					this.$message.error('聊天转为线索失败');
					this.convclose();
				}
			} catch (error) {
				cb(false);
				this.$message.error('聊天转为线索失败');
			}
		},
	},
	components: { dialogtitle, dialogfooter, formDialog },
};
</script>
<style lang="scss" scoped>
.turn-dialog {
	margin: 0px 0px 20px 100px;
	div {
		margin-bottom: 10px;
	}
}
</style>
